import { CSSProperties } from 'react';
import Maybe from 'graphql/tsutils/Maybe';
import { NumericFormatProps, PatternFormatProps } from 'react-number-format';

import type {
  FileInfo,
  PageBlockStyles,
  PageLink,
  Scalars,
  Theme,
  UserTypes,
  VersionStates,
} from '@/components/common/Providers/GraphqlProvider/generated';

export type LoginType = {
  email: string;
  password: string;
  remember?: boolean;
  // dependency: string;
};

export type DialogType = 'success' | 'info' | 'error';

export type UserInfoType =
  | {
      __typename?: 'User';
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      middleName?: string | null;
      secondSurname?: string | null;
      email: string;
      phoneNumber?: string | null;
      type: UserTypes;
      phoneVerification: boolean;
      emailVerification: boolean;
    }
  | undefined;

export type TabSocialNetworkType = {
  id: string;
  description: string;
  linkItem: PageLink;
  createdAt?: any;
  updatedAt?: any;
  typeName?: 'PageSocialNetworksLeftBlockItem' | undefined | string;
  orderIndex: number;
};

export type CarouselSocialNetworkType = {
  id: string;
  description: string;
  alternativeText: string | undefined;
  image: FileInfo;
  linkItem: PageLink;
  createdAt: any;
  updatedAt: any;
  typeName: 'PageSocialNetworksRightBlockItem' | undefined | string;
  orderIndex: number;
};

export type SocialNetworkDetailType =
  | {
      blockTitle: string;
      description: string;
      publicDescription: string;
      showTitle: boolean;
      showDescription: boolean;
      style: PageBlockStyles | undefined | null;
      tabList: TabSocialNetworkType[];
      carouselList: CarouselSocialNetworkType[];
    }
  | undefined;

export type PageBlockVersionType = {
  id: string;
  version: {
    id: string;
    description: string;
    state: VersionStates;
    theme: Theme;
  };
};

export enum TargetType {
  _blank = '_blank',
  _self = '_self',
}

type BasicInputs = {
  label?: string;
  labelClass?: string;
  containerClass?: string;
  containerStyles?: CSSProperties;
  fieldError?: string | undefined;
  tooltip?: string;
};

type ReactInput = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export type CheckBoxProps = Omit<BasicInputs, 'type'> & ReactInput;

export type SelectProps = React.DetailedHTMLProps<
  React.SelectHTMLAttributes<HTMLSelectElement>,
  HTMLSelectElement
> &
  BasicInputs & {
    selectOptions: Record<string, any>[];
    optionsEntries: [string, string];
  };
export type PropsFormSelect = SelectProps & { currentId: string };
export type TextAreaProps = React.DetailedHTMLProps<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
> &
  BasicInputs & { showLength?: boolean; actualLength?: number };
export type PropsFormTextArea = TextAreaProps & { currentId: string; showLength?: boolean };

export type RadioProps = Omit<BasicInputs, 'type'> & ReactInput;
export type PropsRadioInput = RadioProps & { currentId: string };

export type InputProps = ReactInput &
  BasicInputs & {
    type?: Omit<
      React.HTMLInputTypeAttribute,
      'search' | 'button' | 'checkbox' | 'file' | 'radio' | 'reset' | 'submit' | 'color'
    >;
    showErrorMessage?: boolean;
  };
export type PropsSelectFormList = InputProps & {
  currentId: string;
  options: { label: string; value: any }[];
};

export type InputMoneyProps = BasicInputs & NumericFormatProps;
export type PropsCalcInput = InputMoneyProps & { currentId: string; exact?: boolean };
export type InputPatternProps = BasicInputs & PatternFormatProps;
export type PropsPatternInput = InputPatternProps & { currentId: string; exact?: boolean };

export interface CamundaFormCustom extends CamundaField {
  [key: string]: any;
}

type CamundaFormLayout = {
  __typename?: 'CamundaFormLayout';
  columns?: Maybe<Scalars['String']['output']>;
  row?: Maybe<Scalars['String']['output']>;
};

type CamundaFormValidate = {
  __typename?: 'CamundaFormValidate';
  max?: Maybe<Scalars['Int']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  validationType?: Maybe<Scalars['String']['output']>;
};

export type CamundaField = {
  __typename?: 'CamundaField';
  conditional?: Maybe<Scalars['JSONObject']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fieldResponse?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  dateLabel?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<CamundaFormLayout>;
  properties?: Maybe<Scalars['JSONObject']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  timeInterval?: Maybe<Scalars['Int']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  timeLabel?: Maybe<Scalars['String']['output']>;
  timeSerializingFormat?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  use24h?: Maybe<Scalars['Boolean']['output']>;
  validate?: Maybe<CamundaFormValidate>;
  values?: Maybe<Array<CamundaFormOptions>>;
};

type CamundaFormOptions = {
  __typename?: 'CamundaFormOptions';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PropsFormInput = InputProps & { currentId: string };
export type PropsCheckBoxInput = CheckBoxProps & { currentId: string };
